import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StepperState {
  currentStep: number;
  stepHistory: number[];
}

const initialState: StepperState = {
  currentStep: 1,
  stepHistory: [1], // Comienza con el paso inicial
};

const stepperSlice = createSlice({
  name: "stepper",
  initialState,
  reducers: {
    setStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    addStep: (state, action: PayloadAction<number>) => {
      const nextStep = action.payload;
      if (state.stepHistory[state.stepHistory.length - 1] !== nextStep) {
        state.stepHistory.push(nextStep); // Agrega el nuevo paso si no está repetido
      }
      state.currentStep = nextStep;
    },
    removeLastStep: (state) => {
      if (state.stepHistory.length > 1) {
        state.stepHistory.pop(); // Elimina el último paso
        state.currentStep = state.stepHistory[state.stepHistory.length - 1]; // Actualiza al paso anterior
      } else {
        console.warn("No se puede retroceder más, historial insuficiente.");
      }
    },
    resetStep: (state) => {
      state.currentStep = 1; // Reinicia al paso inicial
      state.stepHistory = [1]; // Reinicia el historial
    },
  },
});

export const { setStep, addStep, removeLastStep, resetStep } = stepperSlice.actions;
export default stepperSlice.reducer;
